import { render } from "./DesktopNav.vue?vue&type=template&id=6bf1f466&scoped=true&ts=true"
import script from "./DesktopNav.vue?vue&type=script&lang=ts"
export * from "./DesktopNav.vue?vue&type=script&lang=ts"

import "./DesktopNav.vue?vue&type=style&index=0&id=6bf1f466&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf1f466"]])

export default __exports__